/**
 * URL base da API, centralizada.
 *
 * Na web, usa NEXT_PUBLIC_API_BASE_URL, incorporada pelo Next.js no build.
 * No Capacitor, usa o ambiente salvo no dispositivo (develop por padrão).
 *
 * A trailing slash é removida para permitir concatenação simples com os paths
 * (ex.: `${API_BASE_URL}/api/auth/login`).
 */
import { ACTIVE_APP_ENVIRONMENT, APP_ENVIRONMENTS } from "./appEnvironment"
import { isNativeApp } from "./platform"

// Native builds use the saved environment, independently of the web .env.local.
// A full WebView reload applies a new choice before any API client is created.
export const API_BASE_URL = (isNativeApp()
  ? APP_ENVIRONMENTS[ACTIVE_APP_ENVIRONMENT].url
  : process.env.NEXT_PUBLIC_API_BASE_URL ?? "https://dev-g3-api.dkro.com.br"
).replace(/\/+$/, "")

/**
 * URL base do portal web (frontend), usada para montar links públicos como o de
 * compartilhamento de submissões.
 *
 * No app nativo (Capacitor), `window.location.origin` é `http://localhost` ou
 * `capacitor://localhost`, que não serve como link público. Usamos o `webUrl` do
 * ambiente ativo, configurado por variável de ambiente no build do APK.
 *
 * Na web, `window.location.origin` já é o domínio correto do deploy.
 */
export const WEB_BASE_URL = (isNativeApp()
  ? APP_ENVIRONMENTS[ACTIVE_APP_ENVIRONMENT].webUrl
  : typeof window !== "undefined"
    ? window.location.origin
    : process.env.NEXT_PUBLIC_SITE_URL ?? ""
).replace(/\/+$/, "")
